import { useState } from 'react';

export default function PackagesGrid() {
  const [selectedCategory, setSelectedCategory] = useState('umrah');

  const umrahPackages = [
    {
      name: 'Essential Umrah',
      duration: '7 Days / 6 Nights',
      price: '£1,299',
      image: 'https://public.readdy.ai/ai/img_res/50005d2967c2e41fb2aebd9e5166f608.jpg',
      highlights: [
        '3 nights in Makkah (3-star hotel)',
        '3 nights in Madinah (3-star hotel)',
        'Return flights from London',
        'Airport transfers',
        'Ziyarat tours included',
        'Experienced guide'
      ],
      hotels: {
        makkah: 'Al Safwah Royale Orchid Hotel or similar',
        madinah: 'Dar Al Taqwa Hotel or similar'
      }
    },
    {
      name: 'Premium Umrah',
      duration: '10 Days / 9 Nights',
      price: '£2,499',
      popular: true,
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20five-star%20hotel%20suite%20in%20Makkah%20with%20elegant%20furnishings%2C%20marble%20bathroom%2C%20panoramic%20Haram%20view%2C%20sophisticated%20Islamic%20art%2C%20premium%20bedding%2C%20modern%20amenities%2C%20warm%20golden%20lighting%2C%20opulent%20interior%20design%2C%20professional%20luxury%20hospitality%20photography%2C%20high-end%20accommodation&width=800&height=600&seq=umrah-premium-001&orientation=landscape',
      highlights: [
        '5 nights in Makkah (5-star hotel)',
        '4 nights in Madinah (5-star hotel)',
        'Return flights from London',
        'Private airport transfers',
        'Comprehensive Ziyarat tours',
        'Dedicated multilingual guide',
        'Daily breakfast & dinner',
        'Close proximity to Haram'
      ],
      hotels: {
        makkah: 'Swissotel Makkah or similar (walking distance to Haram)',
        madinah: 'Pullman Zamzam Madinah or similar'
      }
    },
    {
      name: 'Deluxe Umrah',
      duration: '14 Days / 13 Nights',
      price: '£3,899',
      image: 'https://readdy.ai/api/search-image?query=Ultra-luxurious%20presidential%20suite%20with%20stunning%20Kaaba%20view%20through%20floor-to-ceiling%20windows%2C%20exquisite%20Islamic%20calligraphy%20art%2C%20premium%20marble%20finishes%2C%20designer%20furniture%2C%20spacious%20living%20area%2C%20world-class%20amenities%2C%20breathtaking%20sacred%20view%2C%20professional%20luxury%20hotel%20photography%2C%20exceptional%20interior%20elegance&width=800&height=600&seq=umrah-deluxe-001&orientation=landscape',
      highlights: [
        '7 nights in Makkah (5-star deluxe)',
        '6 nights in Madinah (5-star deluxe)',
        'Business class flights',
        'VIP airport lounge access',
        'Private luxury transfers',
        'Extended Ziyarat tours',
        'Personal concierge service',
        'All meals included',
        'Direct Haram view rooms'
      ],
      hotels: {
        makkah: 'Fairmont Makkah Clock Royal Tower or similar',
        madinah: 'Anwar Al Madinah Movenpick or similar'
      }
    },
    {
      name: 'Family Umrah',
      duration: '10 Days / 9 Nights',
      price: '£1,899',
      image: 'https://readdy.ai/api/search-image?query=Spacious%20family%20hotel%20suite%20with%20connecting%20rooms%2C%20comfortable%20twin%20beds%2C%20child-friendly%20amenities%2C%20bright%20and%20welcoming%20decor%2C%20modern%20Islamic%20design%20elements%2C%20safe%20and%20clean%20environment%2C%20family-oriented%20hospitality%2C%20professional%20hotel%20photography%2C%20warm%20inviting%20atmosphere&width=800&height=600&seq=umrah-family-001&orientation=landscape',
      highlights: [
        '5 nights in Makkah (4-star family hotel)',
        '4 nights in Madinah (4-star family hotel)',
        'Return flights for family (2 adults + 2 children)',
        'Family-friendly transfers',
        'Child-friendly Ziyarat tours',
        'Spacious family rooms',
        'Daily breakfast',
        'Kids under 12 discounted'
      ],
      hotels: {
        makkah: 'Elaf Kinda Hotel or similar',
        madinah: 'Elaf Taiba Hotel or similar'
      }
    }
  ];

  const hajjPackages = [
    {
      name: 'Standard Hajj',
      duration: '14 Days / 13 Nights',
      price: '£5,999',
      image: 'https://readdy.ai/api/search-image?query=Comfortable%20pilgrims%20accommodation%20in%20Mina%20with%20organized%20tent%20setup%2C%20clean%20bedding%20arrangements%2C%20air-conditioned%20facilities%2C%20simple%20and%20functional%20design%2C%20peaceful%20atmosphere%20for%20worship%2C%20professional%20documentation%20photography%2C%20practical%20and%20dignified%20hajj%20lodging&width=800&height=600&seq=hajj-standard-001&orientation=landscape',
      highlights: [
        '5 nights in Makkah (3-star hotel)',
        '5 nights in Madinah (3-star hotel)',
        '3 nights in Mina (air-conditioned tents)',
        'Return flights from London',
        'Full Hajj guidance & support',
        'Experienced Hajj guide',
        'All transfers included',
        'Daily meals during Hajj days'
      ],
      hotels: {
        makkah: 'Al Safwah Royale Orchid Hotel or similar',
        madinah: 'Dar Al Taqwa Hotel or similar',
        mina: 'Premium air-conditioned tents'
      }
    },
    {
      name: 'Premium Hajj',
      duration: '16 Days / 15 Nights',
      price: '£8,999',
      popular: true,
      image: 'https://readdy.ai/api/search-image?query=Premium%20hajj%20accommodation%20with%20superior%20tent%20facilities%20in%20Mina%2C%20comfortable%20seating%20areas%2C%20enhanced%20amenities%2C%20organized%20group%20spaces%2C%20clean%20and%20well-maintained%20environment%2C%20professional%20pilgrimage%20photography%2C%20dignified%20and%20comfortable%20hajj%20experience&width=800&height=600&seq=hajj-premium-001&orientation=landscape',
      highlights: [
        '6 nights in Makkah (5-star hotel)',
        '6 nights in Madinah (5-star hotel)',
        '3 nights in Mina (VIP tents)',
        'Return flights from London',
        'Comprehensive Hajj training',
        'Dedicated multilingual guide',
        'Private group transfers',
        'All meals included',
        'Close proximity to Haram',
        'Medical support available'
      ],
      hotels: {
        makkah: 'Swissotel Makkah or similar',
        madinah: 'Pullman Zamzam Madinah or similar',
        mina: 'VIP air-conditioned tents with enhanced facilities'
      }
    },
    {
      name: 'Deluxe Hajj',
      duration: '18 Days / 17 Nights',
      price: '£12,999',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20VIP%20hajj%20tent%20accommodation%20with%20premium%20furnishings%2C%20spacious%20private%20sections%2C%20high-end%20amenities%2C%20elegant%20Islamic%20decor%2C%20superior%20comfort%20for%20pilgrims%2C%20professional%20luxury%20pilgrimage%20photography%2C%20exceptional%20hajj%20hospitality%20experience&width=800&height=600&seq=hajj-deluxe-001&orientation=landscape',
      highlights: [
        '8 nights in Makkah (5-star deluxe)',
        '7 nights in Madinah (5-star deluxe)',
        '3 nights in Mina (luxury VIP tents)',
        'Business class flights',
        'VIP airport services',
        'Personal Hajj mentor',
        'Private luxury transfers',
        'Premium meal service',
        'Direct Haram view rooms',
        '24/7 concierge & medical support',
        'Extended spiritual programs'
      ],
      hotels: {
        makkah: 'Fairmont Makkah Clock Royal Tower or similar',
        madinah: 'Anwar Al Madinah Movenpick or similar',
        mina: 'Luxury VIP tents with private facilities'
      }
    }
  ];

  const packages = selectedCategory === 'umrah' ? umrahPackages : hajjPackages;

  return (
    <section id="packages" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /Choose Your Journey
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#3A2F2B] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our Packages
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-12">
            Select from our carefully designed packages, each crafted to provide comfort, spiritual fulfillment, and exceptional service throughout your sacred journey
          </p>

          <div className="inline-flex bg-white rounded-full p-1 shadow-md">
            <button
              onClick={() => setSelectedCategory('umrah')}
              className={`px-8 py-3 rounded-full text-base font-semibold transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === 'umrah'
                  ? 'bg-[#1A1F2E] text-white'
                  : 'text-gray-600 hover:text-[#1A1F2E]'
              }`}
            >
              Umrah Packages
            </button>
            <button
              onClick={() => setSelectedCategory('hajj')}
              className={`px-8 py-3 rounded-full text-base font-semibold transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === 'hajj'
                  ? 'bg-[#1A1F2E] text-white'
                  : 'text-gray-600 hover:text-[#1A1F2E]'
              }`}
            >
              Hajj Packages
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                pkg.popular ? 'ring-2 ring-[#C9A961]' : ''
              }`}
            >
              {pkg.popular && (
                <div className="bg-[#C9A961] text-white text-center py-2 text-sm font-semibold">
                  Most Popular
                </div>
              )}
              
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-[#1A1F2E] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {pkg.name}
                </h3>
                <p className="text-gray-600 mb-4">{pkg.duration}</p>
                
                <div className="mb-6">
                  <span className="text-4xl font-bold text-[#C9A961]">{pkg.price}</span>
                  <span className="text-gray-600 ml-2">per person</span>
                </div>

                <div className="mb-6">
                  <h4 className="font-semibold text-[#1A1F2E] mb-3">Package Includes:</h4>
                  <ul className="space-y-2">
                    {pkg.highlights.map((highlight, idx) => (
                      <li key={idx} className="flex items-start text-sm text-gray-700">
                        <i className="ri-check-line text-[#C9A961] text-lg mr-2 flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                        <span>{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mb-6 p-4 bg-[#FAF8F5] rounded-lg">
                  <h4 className="font-semibold text-[#1A1F2E] mb-2 text-sm">Accommodation:</h4>
                  <p className="text-xs text-gray-700 mb-1">
                    <strong>Makkah:</strong> {pkg.hotels.makkah}
                  </p>
                  <p className="text-xs text-gray-700 mb-1">
                    <strong>Madinah:</strong> {pkg.hotels.madinah}
                  </p>
                  {pkg.hotels.mina && (
                    <p className="text-xs text-gray-700">
                      <strong>Mina:</strong> {pkg.hotels.mina}
                    </p>
                  )}
                </div>

                <button 
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="w-full px-6 py-3 bg-[#1A1F2E] text-white rounded-lg text-base font-semibold hover:bg-[#2A3F4E] transition-all whitespace-nowrap cursor-pointer"
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Need a custom package? Our travel advisors can create a bespoke itinerary tailored to your needs.
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-10 py-4 bg-[#C9A961] text-white rounded-lg text-lg font-semibold hover:bg-[#B89951] transition-all whitespace-nowrap cursor-pointer"
          >
            Request Custom Package
          </button>
        </div>
      </div>
    </section>
  );
}
